import { render, staticRenderFns } from "./CarouselMod.vue?vue&type=template&id=c24906d2"
import script from "./CarouselMod.vue?vue&type=script&lang=js"
export * from "./CarouselMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports